import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'synonyms',
                label: 'Grupos de Sinônimos',
                routerLink: ['/extensions/synonyms'],
                icon: 'tags',
                requiresPermission: (userPermissions) =>
                    userPermissions.includes('ReadSynonym'),
            },
            'settings'
        ),
    ],
})
export class SynonymGroupNavModule {}
